import type { PhotoCaptureResult } from '../../types/photo';

/**
 * Which of the photos coming back from "Editar todas" actually have to be sent.
 *
 * The grid is seeded with the photos already on file, and those are display-only: a stored
 * photo is passed in as `{ base64: <url>, blob: null }` because there is no file to re-send,
 * only somewhere to show. Posting them back would re-encode and re-upload photos nobody
 * touched, and for a URL-seeded entry there is no blob to post at all.
 *
 * So the blob IS the signal: it exists only for a photo framed in this session.
 */
export function photosToUpload(
  photos: Partial<Record<string, PhotoCaptureResult | null | undefined>>,
): Array<{ photoType: string; blob: Blob }> {
  return Object.entries(photos ?? {})
    .filter(([, photo]) => photo?.blob instanceof Blob && photo.blob.size > 0)
    .map(([photoType, photo]) => ({ photoType, blob: photo!.blob }));
}
